export default {
  order_again: 'Comandă din nou',
  error_messages: {
    product_does_not_exist: 'Produsul nu mai este disponibil',
  },
  success_messages: {
    product_added_to_card: 'Produs adăugat în coș',
  },
};
